namespace Areas.Staff.EmailBlast {
    "use strict";

    let emailBlastId: number;
    let runQuery: boolean = false;

    export function onGridSelectionChanged(e) {
        const rowSelected = e.selectedRowsData.length === 1;

        if (rowSelected) {
            const status: string = e.selectedRowsData[0].emailDateTime;
            const canBeModified = (status == null);

            if (!canBeModified) {
                enableButton("EditButton");
            } else {
                disableButton("EditButton");
            }
        }
    }


    export function viewEditLink(cellElement: any, cellInfo: any) {
        const getData = () => { return cellInfo.data.emailBlastId; };

        if (status == null) {
            buildCellContent(cellElement, getData, "<a href= '/Staff/EmailBlast/Edit/{placeholder}'>Edit</a>");
        } else {
            buildCellContent(cellElement, getData, "<a href= '/Staff/EmailBlast/View/{placeholder}'>View</a>");
        }
    }

    export function addEmailBlast() {
        const createEmailBlastDialog = new Areas.Dialogs.CreateEmailBlastDialog(() => { });
    }

    export function viewEmailBlast() {

        var dataGrid = $('#EmailBlastListGrid').dxDataGrid('instance');
        var dataId = dataGrid.getSelectedRowKeys()[0];
        if (dataId != null) {
            var linkInfo = "/Staff/EmailBlast/View/" + dataId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
       
    }

    export function editEmailBlast() {
        var dataGrid = $('#EmailBlastListGrid').dxDataGrid('instance');
        var dataId = dataGrid.getSelectedRowKeys()[0];
        if (dataId != null) {
            var linkInfo = "/Staff/EmailBlast/Edit/" + dataId.toString() + "";
            location.href = linkInfo;
        } else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }

    export function gotoEditFromForm() {
        var keyId: any = $('#EmailBlastForm').dxForm('instance').option('KeyId');
        if (keyId != null) {
            var linkInfo = "/Staff/EmailBlast/Edit/" + keyId.toString() + "";
            location.href = linkInfo;
        }
    }

    export function getEmailBlast() {
        runQuery = true;
        
        var data: any = $('#EmailBlastForm').dxForm('instance').option('formData');
        emailBlastId = data.EmailBlastId;

        enableButton("ProcessButton");
        updateRecord();   //callback refreshes Grid
    }

    export function canExecuteQuery() {
        return runQuery;
    }

    export function getEmailBlastId() {
        return emailBlastId;
    }

    export function getRequestLogIdFromForm() {
        var data: any = $('#EmailBlastForm').dxForm('instance').option('formData');
        emailBlastId = data.EmailBlastId;
    }

    export function processEmailBlast() {

        disableButton("ProcessButton");
        const mainForm = $("#EmailBlastForm").dxForm("instance");

        const newData: any = mainForm.option("formData");
        emailBlastId = newData.EmailBlastId;

        var data: any = {
            EmailBlastFormData: JSON.stringify(newData.EmailBlastRecord),
            EmailBlastId: newData.EmailBlastRecord.EmailBlastId,
        };

        sendRequest("/Staff/EmailBlast/ProcessEmailBlastRequestLog", JSON.stringify(data), "PUT", () => { });
    }

    export function goToList() {
        var linkInfo = "/Staff/EmailBlast/Index";
        location.href = linkInfo;
    }

    export function updateRecord() {
        const form = $("#EmailBlastForm").dxForm("instance");
        const newData: any = form.option("formData");
        const result: any = form.validate();

        if (result.isValid) {
  
            //License   &  Specialty
            const licenseGrid = $("#LicenseGrid").dxDataGrid("instance");
            const specialtyGrid = $("#SpecialtyGrid").dxDataGrid("instance");

            var types = licenseGrid.getSelectedRowKeys();
            var specialties = specialtyGrid.getSelectedRowKeys();
            var emailBlastId = licenseGrid.option("EmailBlastId");
            var emailSubject = newData.EmailBlastRecord.EmailSubject;
            var emailBody = newData.EmailBlastRecord.EmailBody;
            var emailType = newData.EmailBlastRecord.EmailType;
            var emailDateTime = newData.EmailBlastRecord.EmailDateTime;

            var data: any = {
                EmailBlastFormData: JSON.stringify(newData.EmailBlastRecord),
                EmailBlastId: emailBlastId,
                EmailSubject: emailSubject,
                EmailBody: emailBody,
                EmailType: emailType,
                EmailDateTime: emailDateTime,
                LicenseTypes: types,
                SpecialtyCodes: specialties
            };
            sendRequest("/Staff/EmailBlast/Put/", JSON.stringify(data), "PUT", () => { reloadPage()});
        }

    }

    //License
    export function onLicenseGridContentReady(e: any) {
        var emailBlastId = e.component.option("EmailBlastId") as number;
        getEmailBlastLogLicenseTypes(emailBlastId);
    }

    export function getEmailBlastLogLicenseTypes(emailBlastId: number) {
        var checkGrid = $("#LicenseGrid").dxDataGrid("instance");

        $.ajax({
            url: `/Staff/EmailBlast/GetEmailBlastLogLicenseTypes/${emailBlastId}`,
            method: "GET",
            contentType: "application/json",
            success: (data) => {
                checkGrid.selectRows(data, false);
            },
            error: () => {
                DevExpress.ui.notify("Error getting license types for Licenses List Log.", "error", 2000);
            }
        });
    }

    //Specialty
    export function onSpecialtyGridContentReady(e: any) {
        var emailBlastId = e.component.option("EmailBlastId") as number;
        getEmailBlastLogSpecialtyCodes(emailBlastId);
    }

    export function getEmailBlastLogSpecialtyCodes(emailBlastId: number) {
        var checkGrid = $("#SpecialtyGrid").dxDataGrid("instance");

        $.ajax({
            url: `/Staff/EmailBlast/GetEmailBlastLogSpecialtyCodes/${emailBlastId}`,
            method: "GET",
            contentType: "application/json",
            success: (data) => {
                checkGrid.selectRows(data, false);
            },
            error: () => {
                DevExpress.ui.notify("Error getting specialty codes for Specialties List Log.", "error", 2000);
            }
        });
    }

    export function deleteRecord() {
        const verifyVoid = window.confirm("Are you sure you would like to VOID this record?");

        if (verifyVoid) {
            const form = $("#EmailBlastForm").dxForm("instance");
            const keyId: any = form.option("KeyId");

            if (keyId != null) {
                sendRequest(`/EmailBlast/EmailBlast/Delete/${keyId}/`, "", "DELETE");
            }
        }
    }

}